// extracted by mini-css-extract-plugin
export default {"plusIcon":"plusIcon__BxyYeS","label":"label__mw6Y9R"};